import parse, { domToReact } from 'html-react-parser';
import { useMemo, useEffect, useRef, Fragment } from 'react';

import styles from './Html.module.scss';

const parseHtmlAndWrapTables = html => {
	return parse(html || '', {
		replace: ({ name, children }) => {
			if (name && name === 'table') {
				return (
					<div className='table-wrapper'>
						<div className='table-inner'>
							<table>
								{domToReact(children, {
									replace: ({ type, next, prev }) => {
										// to avoid warning 'Whitespace text nodes cannot appear as a child of <table>'
										if (type === 'text') {
											if (next) {
												return <></>;
											}
											if (prev) {
												return <></>;
											}
										}
									},
								})}
							</table>
						</div>
					</div>
				);
			}
		},
	});
};

const checkScrollPosition = target => {
	const { scrollWidth } = target;
	const { scrollLeft } = target;
	const { offsetWidth } = target;

	const nextFromStart = scrollLeft > 5;
	const nextReachEnd = scrollWidth - scrollLeft - offsetWidth < 5;

	const prevReachEnd = !target.parentNode.classList.contains('shadow-right');
	const prevFromStart = target.parentNode.classList.contains('shadow-left');

	if (prevReachEnd !== nextReachEnd) {
		target.parentNode.classList.toggle('shadow-right', !nextReachEnd);
	}

	if (prevFromStart !== nextFromStart) {
		target.parentNode.classList.toggle('shadow-left', nextFromStart);
	}
};

const Html = ({ html }) => {
	const blockRef = useRef(null);

	useEffect(() => {
		const tables = blockRef.current.querySelectorAll('.table-inner');

		const functions = [];
		if (tables.length > 0) {
			tables.forEach(table => {
				checkScrollPosition(table, true);
				const fun = () => checkScrollPosition(table);
				table.addEventListener('scroll', fun);
				functions.push(fun);
			});
		}

		return () => {
			if (tables.length > 0) {
				tables.forEach((table, ind) => {
					table.removeEventListener('scroll', functions[ind]);
				});
			}
		};
	}, [html]);

	const htmlContentComponent = useMemo(() => parseHtmlAndWrapTables(html));

	return (
		<div ref={blockRef} className={styles.container}>
			{htmlContentComponent}
		</div>
	);
};

export default Html;
